import Api from "@/repository/api";
import qs from "qs";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";
import {
    IServicesCategoryNomenclatureRepository
} from "@/repository/servicesCategory/ServicesCategoryNomenclatureRepository.types";
import {
    IServicesCategoryNomenclature, IServicesCategoryNomenclatureListItem, ServicesCategoryNomenclatureResponseType
} from "@/entity/servicesCategoryNomenclature/services.category.nomenclature.types";
import ServicesCategoryNomenclature from "@/entity/servicesCategoryNomenclature/services.category.nomenclature";
import {ServiceCategoryCreateRequestType} from "@/form/serviceCategory/serviceCategoryCreate.types";

export class ServicesCategoryNomenclatureRepository implements IServicesCategoryNomenclatureRepository {

    async fetchAll(data?: FormData, mode?: boolean): Promise<IServicesCategoryNomenclature> {
        const response = await Api.get('/service_category/nomenclature/get', {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString()
            }
        });
        const responseData = response.data as ServicesCategoryNomenclatureResponseType;
        return new ServicesCategoryNomenclature(responseData);
    }

    async fetchData(data: PaginationRequestType, mode?: boolean): Promise<IServicesCategoryNomenclatureListItem> {
        const response = await Api.get('/service_category/nomenclature/get', {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }
        });
        const responseData = response.data as ServicesCategoryNomenclatureResponseType;
        return new ServicesCategoryNomenclature(responseData).data[0];
    }

    async create(data: ServiceCategoryCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service_category/nomenclature/create`, data);
        const responseData = response.data;
        return responseData;
    }

    async update(data: ServiceCategoryCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service_category/nomenclature/update`, data);
        const responseData = response.data;
        return responseData;
    }

    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/service_category/nomenclature/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}